
export default class Rect
{
    x;
    y;
    w;
    h;
    constructor(x,y,w,h)
    {
        this.x = x|0;
        this.y = y|0;
        this.w = w|0;
        this.h = h|0;
    }

    get center()
    {
        return [0|(this.x + this.w/2), 0|(this.y + this.h/2)]
    }

    offset(left, top = left, right = left, bottom = top)
    {
        return new Rect(
        this.x + left,
        this.y + top,
        this.w - (left + right),
        this.h - (top + bottom),
        )
    }
}
